/**
 * Texts for Library page
 */
export const libraryPageText = {
    title: 'CamAPS Liberty - CamAPS FX',
    titleMeta: 'CamAPS Liberty - CamAPS FX',
    descriptionMeta: 'Access resources and support materials for CamAPS FX and CamAPS Liberty®.',
    keywords: 'camaps library, camaps fx, camaps liberty, support resources, diabetes management',
    localeMeta: 'en_ca',

    bannerTitle: 'Support beyond the numbers',
    bannerSubtitle: 'with CamAPS Liberty<sup>®</sup>',
    bannerDescription: 'When activated, users will not need to count carbohydrates and deliver a pre-meal insulin bolus.',
    bannerCompatibility: 'Android and iOS compatible',
    
    announcementText: 'Coming soon to Dana CamAPS FX and myLoop users*',
    announcementDisclaimer: '* Pending local market approvals and availability',

    introTitle: "The first fully closed-loop feature. When you need it.",
    introDescription: 'When activated, users will not need to count carbohydrates and deliver a pre-meal insulin bolus.',
    introSubtext: 'Available on Android and Apple operating systems',

    howItWorksTitle: 'How does it work?',
    howItWorksDescription: 'Powered by a more proactive version of the CamAPS algorithm. CamAPS Liberty anticipates and responds to glucose changes while maintaining established safety boundaries.',
    
    step1Title: 'STEP 1',
    step1Description: 'From your home screen, head to the settings menu.',
    step2Title: 'STEP 2',
    step2Description: 'Scroll down to the bottom and tap the toggle to activate.',
    step3Title: 'STEP 3',
    step3Description: 'On first use, you\'ll need to watch our explainer video about CamAPS Liberty.',
    step4Title: 'STEP 4',
    step4Description: 'Confirm you are not under 13 years old or pregnant.',
    step5Title: 'STEP 5',
    step5Description: 'Tap the toggle again to activate.',
    step6Title: 'STEP 6',
    step6Description: "You're all set. The CamAPS Liberty tab will appear on your home screen<sup>†</sup>.",
    step6Footnote: "<sup>†</sup> Only works while \"Auto mode\" is on",

    eligibilityTitle: 'Who can use CamAPS Liberty?',
    eligibilityCriterion1: 'Existing users with type 1 diabetes',
    eligibilityCriterion2: '13 years and older',
    eligibilityCriterion3: 'Pregnant',
    parentsCarersTitle: 'What about parents and carers?',
    parentsCarersBlockTitle: '\'Block\' function:',
    parentsCarersBlockDescription: 'To prevent accidental use',
    parentsCarersRemoteTitle: 'Remote monitoring:',
    parentsCarersRemoteDescription: 'Companion, Glooko® and CamAPS 2-week PDF reports',
    
    imageOverlayText: 'Designed to work alongside your current diabetes management plan; not replace it.',
    
    usingTitle: 'Using CamAPS Liberty',
    
    treatmentPlanText: 'CamAPS Liberty is designed to remove the need for routine meal boluses. It does not replace the other elements of the user\'s diabetes management plan, including regular review with the diabetes team.',
    
    usingLibertyTitle: 'Watch and learn about CamAPS Liberty',
    usingLibertyDescription: 'Explore videos to learn more about CamAPS Liberty and how to get started.',
    // latestVideoLabel removed
    moreVideosLabel: 'More videos',
    factsheetDownloadText: 'CamAPS Liberty factsheet (pdf)',
    factsheetUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/camaps_liberty_faqs_en.pdf',
    usingLibertyFeaturedVideo: {
        youtubeUrl: 'https://youtu.be/px9QSOhy544',
        title: 'CamAPS Liberty: Getting started',
        description: 'Candice Ward explains how to get set up and start using CamAPS Liberty.',
        duration: '31:50',
        date: '15 Sep 2026',
    },
    usingLibertyMoreVideos: [
        {
            youtubeUrl: 'https://youtu.be/QAYy8dTXUUc',
            title: 'Practical Tips: CamAPS Liberty',
            duration: '01:49',
        },
        {
            youtubeUrl: 'https://youtu.be/K7_j-Sk5Fas',
            title: 'Introducing CamAPS Liberty',
            duration: '14:42',
        },
        {
            youtubeUrl: 'https://youtu.be/0dp5A8z_SEk',
            title: 'CamAPS Liberty - early user feedback',
            duration: '04:22',
        },
        {
            youtubeUrl: 'https://youtu.be/W-7cq3CQ7pg',
            title: 'The CamAPS Liberty feature',
            duration: '03:16',
        }
    ],
    
    whatHappensNextTitle: 'What happens next?',
    whatHappensNextText: 'We\'ll be running a pilot within a single market in the coming months. Stay tuned for more details.',
};

